import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'

Vue.use(VueResource)

export class UserApi {
	constructor () {
		this.accessToken = container.get('services.oauth') ? container.get('services.oauth').getToken() : null
	}

	getUrl()
	{
		let url = process.env.VUE_APP_API_URL

		if (container.get("source").getValue() == "bennet") {
      url = "https://sigma-instacook.bennet.com:8214/v1";
    }
    
    return url;
	}

	/**
	 * Request the provider access_token from code
	 *
	 * @param {string} provider_name
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	oauthProviderRequestToken (providerName, params) {
		return Vue.http.post(this.getUrl() + '/oauth/' + providerName + '/access_token', params, { withCredentials:true}).then(response => {
			params.access_token = response.body.data.resource.access_token
			return this.oauthProviderExchangeToken(providerName, params)
		})
	}

	/**
	 * Request the provider access_token from code
	 *
	 * @param {string} provider_name
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	oauthProviderDeleteToken (providerName, params) {
		return Vue.http.post(this.getUrl() + '/oauth/' + providerName + '/delete_token', params, { withCredentials:true })
	}

	/**
	 * Request the provider access_token from code
	 *
	 * @param {string} provider_name
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	oauthProviderRemoveToken (providerName, params) {
		return Vue.http.post(this.getUrl() + '/oauth/' + providerName + '/access_token', params, { withCredentials:true}).then(response => {
			params.access_token = response.body.data.resource.access_token
			return this.oauthProviderDeleteToken(providerName, params)
		})
	}

	/**
	 * Convert an external access_token to internal access_token
	 *
	 * @param {string} provider_name
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	oauthProviderExchangeToken (providerName, params) {
		return Vue.http.post(this.getUrl() + '/oauth/' + providerName + '/exchange_token', params, { withCredentials:true, headers: {
			Authorization: container.get('services.oauth') ? 'Bearer ' + container.get('services.oauth').getToken() : null
		}})
	}

	/**
	 * Sign in
	 *
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	signIn (params) {
		return Vue.http.post(this.getUrl() + '/oauth/sign-in', params)
	}

	signInEmail (email) {
		var params = {
			email: email,
			redirect_url: location.protocol + '//' + location.host
		}
		return Vue.http.post(this.getUrl() + '/sign-in-email', params)
	}

	signInAuthToken (token) {
		var params = {
			auth_token: token
		}

		return Vue.http.post(this.getUrl() + '/sign-in-auth-token', params)
	}

	/**
	 * Sign up
	 *
	 * @param {Object} params
	 *
	 * @return {Promise}
	 */
	signUp (params) {
		// Add params ref_friend

		params.ref_friend = container.get('services.cookies').get('ref_invite', '/')
		params.ref = container.get('services.cookies').get('ref', '/')

		params.utm_source = container.get('services.cookies').get('utm_source', '/')
		params.utm_name = container.get('services.cookies').get('utm_name', '/')
		params.utm_campaign = container.get('services.cookies').get('utm_campaign', '/')
		params.utm_medium = container.get('services.cookies').get('utm_medium', '/')
		params.referrer = container.get('services.cookies').get('referrer', '/')
		params.source = container.get('source').getValue('default')

		return Vue.http.post(this.getUrl() + '/register', params, { headers: {
			Authorization: container.get('services.oauth') ? 'Bearer ' + container.get('services.oauth').getToken() : null
		}})
	}

	/**
	 * Get user
	 *
	 * @param {String} access_token
	 *
	 * @return {Promise}
	 */
	getUser (accessToken) {
		var date = new Date()
		return Vue.http.get(this.getUrl() + '/me/profile', { params: { t: date.getTime()/1000|0 }, headers: {
			Authorization: 'Bearer ' + accessToken
		}})
	}

	/**
	 * Get recurring
	 *
	 * @param {String} access_token
	 *
	 * @return {Promise}
	 */
	getRecurring () {
		var date = new Date()
		return Vue.http.get(this.getUrl() + '/me/recurring', { params: { t: date.getTime()/1000|0 }, headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}


	createGuest (params) {

		if (!params) {
			params = {}
		}

		params.source = container.get('source').getValue('default')

		return Vue.http.post(this.getUrl() + '/guest', params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}

	changePassword (params) {
		return Vue.http.post(this.getUrl() + '/me/password', params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}

  changeRecurring (params) {
    return Vue.http.post(this.getUrl() + '/me/recurring', params, { headers: {
      Authorization: 'Bearer ' + this.accessToken
    }})
  }

  changeConsentMarketing (params) {
    return Vue.http.post(this.getUrl() + '/me/consent-marketing', params, { headers: {
      Authorization: 'Bearer ' + this.accessToken
    }})
  }
	
  orders (params) {
		return Vue.http.get(this.getUrl() + '/me/orders', { params,
			headers: {
				Authorization: 'Bearer ' + this.accessToken
			}})
	}

	invite (params) {
		return Vue.http.post(this.getUrl() + '/me/invite', params, { headers: {
			Authorization: 'Bearer ' + this.accessToken
		}})
	}

	discount () {
		return Vue.http.get(this.getUrl() + '/me/discounts/active', { params: {},
			headers: {
				Authorization: 'Bearer ' + this.accessToken
			}})
	}

	wallet () {
		return Vue.http.get(this.getUrl() + '/me/wallet', { params: {},
			headers: {
				Authorization: 'Bearer ' + this.accessToken
			}})
	}
}
